import {forEach} from 'lodash';
import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';
export default function BulkTaskSeeTask(state = initialState.bulkTaskSeeTask, action) {
	switch (action.type) {
		case types.BULK_TASK_ADD_TASK_TO_SELECTED_TASKS: {
			let tempState = _.cloneDeep(state);
			forEach(action.data, (t) => {
				tempState.set(t.id, t);
			});
			return tempState;
		}
		case types.BULK_TASK_REMOVE_TASK_FROM_SELECTED_TASKS: {
			let tempState = _.cloneDeep(state);
			forEach(action.data, (t) => {
				delete tempState.delete(t.id);
			});
			return tempState;
		}

		case types.BULK_TASK_ADD_ALL_TASKS_TO_SELECTED_TASKS: {
			let tempState = new Map();
			forEach(action.data, (t) => {
				tempState.set(t.id, t);
			});
			return tempState;
		}

		case types.BULK_TASK_REMOVE_ALL_TASKS_FROM_SELECTED_TASKS: {
			return new Map();
		}
		default:
			return state;
	}
}
